<div class="header-actions">
  @if (headerIcon || headerTitle || headerDescription || showBackButton) {
  <div class="header-row">
    <div class="header-info">
      @if (showBackButton) {
      <app-button variant="ghost" [icon]="faArrowLeft" size="medium" (clicked)="onBackClick()">
      </app-button>
      }
      @if (headerIcon) {
      <fa-icon [icon]="headerIcon" class="header-icon"></fa-icon>
      }
      <div class="header-texts">
        @if (headerTitle) {
        <div class="header-title">{{ headerTitle | translate }}</div>
        }
        @if (headerDescription) {
        <div class="header-description">{{ headerDescription | translate }}</div>
        }
      </div>
    </div>
    <div class="actions-group">
      @if (showAddButton) {
      <app-button variant="primary" [text]="config.addButton?.text ? getAddButtonText() : undefined"
        [icon]="config.addButton?.icon || faPlus" [disabled]="!!config.addButton?.disabled" (clicked)="onAddClick()">
      </app-button>
      }
      @if (showHelpButton) {
      <app-button variant="ghost" [icon]="config.helpButton?.icon || faQuestionCircle"
        [disabled]="!!config.helpButton?.disabled" (clicked)="onHelpClick()">
      </app-button>
      }
      @if (hasCustomButtons) {
      @for (btn of config.customButtons; track btn; let i = $index) {
      <app-button [variant]="btn.customClass === 'btn-primary' ? 'primary' : 'secondary'"
        [text]="btn.text ? getButtonText(btn) : undefined" [icon]="btn.icon" [disabled]="!!btn.disabled"
        (clicked)="onCustomButtonClick(btn, i)">
      </app-button>
      }
      }
    </div>
  </div>
  @if (showSearch) {
  <div class="header-search">
    <app-search [config]="config.searchConfig!" [initialFilters]="initialFilters"
      (filtersChanged)="onSearchFiltersChanged($event)" (searchCleared)="onSearchCleared()"
      (tagFilterCleared)="onTagFilterCleared()" (allFiltersCleared)="onAllFiltersCleared()">
    </app-search>
  </div>
  }
  } @else {
  <div class="header-row">
    <div class="header-search" style="flex:1;">
      <app-search [config]="config.searchConfig!" [initialFilters]="initialFilters"
        (filtersChanged)="onSearchFiltersChanged($event)" (searchCleared)="onSearchCleared()"
        (tagFilterCleared)="onTagFilterCleared()" (allFiltersCleared)="onAllFiltersCleared()">
      </app-search>
    </div>
    <div class="actions-group">
      @if (showAddButton) {
      <app-button variant="primary" [text]="config.addButton?.text ? getAddButtonText() : undefined"
        [icon]="config.addButton?.icon || faPlus" [disabled]="!!config.addButton?.disabled" (clicked)="onAddClick()">
      </app-button>
      }
      @if (showHelpButton) {
      <app-button variant="ghost" [icon]="config.helpButton?.icon || faQuestionCircle"
        [disabled]="!!config.helpButton?.disabled" (clicked)="onHelpClick()">
      </app-button>
      }
      @if (hasCustomButtons) {
      @for (btn of config.customButtons; track btn; let i = $index) {
      <app-button [variant]="btn.customClass === 'btn-primary' ? 'primary' : 'secondary'"
        [text]="btn.text ? getButtonText(btn) : undefined" [icon]="btn.icon" [disabled]="!!btn.disabled"
        (clicked)="onCustomButtonClick(btn, i)">
      </app-button>
      }
      }
    </div>
  </div>
  }
  @if (showCount && count !== null) {
  <div class="header-count">
    {{ count }}
  </div>
  }
</div>